import AOS from 'aos';

AOS.init({
  once: true,
  offset: 220,
  duration: 600,
});

import './contact-form.js';
import './scroll-button.js';

let vh = window.innerHeight * 0.01
document.documentElement.style.setProperty('--vh', `${vh}px`)

window.addEventListener('resize', () => {
  vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})